// extracted by mini-css-extract-plugin
module.exports = {"grid":"ProductsGrid_grid__3n39h","table":"ProductsGrid_table__26SkE","pagination":"ProductsGrid_pagination__3FVry"};